import React from 'react';
import RatingScale from './RatingScale';
import { connect } from "react-redux";
import * as types from "../../../constants/actionTypes";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import { Link, Redirect } from "react-router-dom";
import MiniSpinner from "../../common/MiniSpinner";
import VideoVisitSurvey from "./VideoVisitSurvey";

class AmbulatorySurvey extends React.Component {
    constructor(props) {
        super(props);
        this.onRatingClick = this.onRatingClick.bind(this);
        this.onAVSGotItClick = this.onAVSGotItClick.bind(this);
        this.submitSurvey = this.submitSurvey.bind(this);
        this.state = {
            isSubmitted: false,
            selectedRating: 0
        };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.AmbulatorySurvey.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    onRatingClick(selectedRating) {
        const { userDetails, serverData, isSDCVisit } = this.props;
        let surveyId = null;
        let questionId = null;
        if (isSDCVisit) {
            surveyId = serverData && serverData.surveyIdForSDC ? serverData.surveyIdForSDC : null;
            questionId = serverData && serverData.surveyQuestionIdForSDC ? serverData.surveyQuestionIdForSDC : null;
        } else {
            surveyId = serverData && serverData.surveyIdForAmbulatory ? serverData.surveyIdForAmbulatory : null;
            questionId = serverData && serverData.surveyQuestionIdForAmbulatory ? serverData.surveyQuestionIdForAmbulatory : null;
        }
        const requestData = {
            UserId: userDetails.userName,
            SurveyId: surveyId,
            QuestionId: questionId,
            OptionId: "",
            OptionValue: selectedRating
        };
        let surveyLogValue = {
            Rating: selectedRating,
            visitType: isSDCVisit ? "SDC" : "Ambulatory"
        }
        logUI("MBHWeb.UI.AmbulatorySurvey.Submit.Click", new Date(), Tools.getURLPath(), surveyLogValue);
        this.props.ambulatoryVideoVisitSurveyRequest(requestData);
        this.setState({ selectedRating: selectedRating, isSubmitted: true });
    }

    onDismissClick() {
        logUI("MBHWeb.UI.AmbulatorySurvey.Dismiss.Click", new Date(), Tools.getURLPath());
    }

    onAVSGotItClick() {
        const { enableNewSurvey } = this.props;
        logUI("MBHWeb.UI.AmbulatorySurvey.AVSGotIt.Click", new Date(), Tools.getURLPath());
        this.setState({ showRating: true },
            function () {
                var surveyContainer;
                const windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
                if (typeof window !== 'undefined' && windowWidth < 576) {
                    surveyContainer = window.document.querySelector('.rating-scale');
                    if (surveyContainer && !enableNewSurvey)
                        surveyContainer.scrollLeft = (surveyContainer.scrollWidth && surveyContainer.clientWidth) ? ((surveyContainer.scrollWidth / 2) - (surveyContainer.clientWidth / 2)) : 400;
                }
            });
    }

    submitSurvey() {
        this.setState({ isSubmitted: true });
    }

    render() {
        const { isSubmitted, showRating, selectedRating } = this.state;
        const { isSuccess, isPending, isFailure, enableNewSurvey, twilioUserName, isSDCVisit, isFromNonLogin, externalEventId, enableQualtricsSurvyVideoVisit } = this.props;

        return (
            <div className={!isFromNonLogin ? "container-fluid body-content ambulatory-survey-container" : "ambulatory-survey-container nonloggedin-ambulatory-survey"}>
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        {!showRating && !isFromNonLogin &&
                            <div className="row">
                                <div className="col-12 visit-summary-container">
                                    <div className="row visit-summary__body">
                                        <div className="col-12">
                                            <div className="step-heading-icon success-heading"><span className="svg-thumbs-up" /></div>
                                            <h1 className="step-heading step-heading-md">Video Visit Completed, Thanks!</h1>
                                        </div>
                                        <div className="col-12">
                                            <div className="visit-summary-heading">Your After Visit Summary</div>
                                            <p className="visit-summary">To view your visit summary use the "SEE ALL" link on the Appointments card of the home screen. It may take up to 8 business hours for it to be available.</p>
                                            <img alt="Dashboard Appointment Tile" src="/images/appt-see-all-tile.png" className="img-fluid" />
                                        </div>
                                    </div>
                                    <div className="row visit-summary__footer">
                                        <div className="col-12">
                                            <button className="btn btn-primary" id={enableQualtricsSurvyVideoVisit ? "bsw_qtx_video_visit_completed_click" : ""} onClick={() => { if (!enableQualtricsSurvyVideoVisit) this.onAVSGotItClick() }}>Got It</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {(showRating && !isSubmitted) || isFromNonLogin ?
                            enableNewSurvey ? <VideoVisitSurvey csnId={this.props.csnId} submitSurvey={this.submitSurvey} twilioUserName={twilioUserName} isSDCVisit={isSDCVisit} isFromNonLogin={isFromNonLogin} externalEventId={externalEventId} /> :
                                <div className="row">
                                    <div className="col-12 visit-survey-container">
                                        <div className="row visit-survey__body">
                                            <div className="col-12">
                                                <h1 className="step-heading step-heading-md">On a scale of 1-10, how likely are you to recommend MyBSWHealth Video Visit to a friend or loved one?</h1>
                                                <div className="step-description">HELP US IMPROVE!</div>
                                            </div>
                                            <div className="col-12 rating-scale-container">
                                                <RatingScale
                                                    onRatingClick={this.onRatingClick}
                                                    backgroundColors={["#f4436c", "#d95174", "#be607c", "#a36e84", "#887c8c", "#6c8b93", "#51999b", "#36a7a3", "#1bb6ab", "#00c4b3"]}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <div className="row rating-info">
                                                    <div className="col-6">1 = Not at all likely</div>
                                                    <div className="col-6">10 = Extremely likely</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row visit-survey__footer">
                                            <div className="col-12">
                                                <Link className="btn text-btn" to={{ pathname: "/" }} onClick={this.onDismissClick}>DISMISS</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div> : null
                        }
                        {isPending &&
                            <div className="row">
                                <div className="col-12">
                                    <MiniSpinner />
                                </div>
                            </div>
                        }
                        {!isPending && isSubmitted && !enableNewSurvey ?
                            <div className="row">
                                <div className="col-12 survey-status-container">
                                    <div className="row survey-status__body">
                                        <div className="col-12">
                                            <div className="step-heading-icon success-heading"><span className="icon-echeck-in" /></div>
                                            <h1 className="step-heading step-heading-md success-heading">Thank you for the feedback!{/*isSuccess ? "Thank you for the feedback!" : "Thank you!"*/}</h1>
                                        </div>
                                        {/*isSuccess && selectedRating > 0 && selectedRating < 9 &&
                                            <div className="col-12">
                                                <div className="step-description">We'll be working on ways to improve the experience for you.</div>
                                            </div>
                                        */}
                                    </div>
                                    <div className="row survey-status__footer">
                                        <div className="col-12">
                                            <Link className="btn btn-primary" to={{ pathname: "/" }}>CLOSE</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : !isPending && isSubmitted && enableNewSurvey ? <Redirect to="/" /> : ""
                        }
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.sso.userDetails,
        isPending: state.videoVisitScheduling.videoSurvey && state.videoVisitScheduling.videoSurvey.isWaiting,
        isSuccess: state.videoVisitScheduling.videoSurvey && state.videoVisitScheduling.videoSurvey.isSuccess,
        isFailure: state.videoVisitScheduling.videoSurvey && state.videoVisitScheduling.videoSurvey.isFailure,
        serverData: state.session.serverData,
        enableNewSurvey: state.session.serverData && state.session.serverData.enableNewSurvey,
        enableQualtricsSurvyVideoVisit: state.session.serverData && state.session.serverData.enableQualtricsSurvyVideoVisit
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ambulatoryVideoVisitSurveyRequest: (requestData) => dispatch({ type: types.AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST, data: requestData })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AmbulatorySurvey);